import React, { useState, ReactNode } from 'react';
import { Box, Stack } from '@mui/material';
import { FeedbackInput } from '../../AIStudioModal/components/FeedbackInput';
import { FelixMessageSVG } from '../../SharedComponents/Graphics/FelixSVG';
import { classes as felixClasses } from '../../AIStudioModal/styles';

export const DynamicFooterWithInput = ({
  isLoading,
  submitCallback,
  description,
  suggestedPrompts,
  containerStyle
}: {
  isLoading: boolean;
  submitCallback: (feedbackInput?: string) => void;
  description?: string | ReactNode;
  suggestedPrompts?: string[];
  containerStyle?: React.CSSProperties;
}) => {
  const [feedbackInput, setFeedbackInput] = useState('');

  const handleOnChange = (input: string) => {
    setFeedbackInput(input);
  };

  return (
    <Box
      sx={{ ...felixClasses.footerContainer, width: '100%', padding: '20px 0', ...containerStyle }}
    >
      <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ width: '100%' }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexShrink: 0 }}>
          <FelixMessageSVG />
        </Box>
        <Box sx={{ ...felixClasses.felixMessage, width: '100%', flex: 1 }}>
          <Box sx={{ paddingRight: '80px' }}>{description}</Box>
          <Box sx={{ width: '100%' }}>
            <FeedbackInput
              value={feedbackInput}
              onChange={handleOnChange}
              onSubmit={(value) => submitCallback(value)}
              suggestedPrompts={suggestedPrompts}
              isLoading={isLoading}
              language={'english'}
            />
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};
